/* PeekoraLab - mobile conversion layer - 2026-10-04 (pairs with pk-mobile-cro.css)
   1. Sticky add-to-cart bar hides while the main Add to Cart is on screen.
   2. Review badges: 0 reviews -> hidden; 1-9 reviews -> "N reviews" instead of
      "N Happy Parents"/"Top Rated". Runs after pk-judgeme-happy-parents.js has
      written its label (that script keys re-writes off a signature, so it does
      not fight this). */
(function () {
  'use strict';
  if (window.__PK_MOBILE_CRO__) return;
  window.__PK_MOBILE_CRO__ = true;
  var FR = String(document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;

  /* 1. Sticky bar */
  function watchMainAtc() {
    var main = document.querySelector('.pkcv__info > .pkcv__add, .pkcv__info button.pkcv__add');
    if (!main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { document.body.classList.toggle('pk-main-atc-visible', e.isIntersecting); });
    }, { rootMargin: '0px 0px -60px 0px' }).observe(main);
  }

  /* 2. Honest review badges */
  function fixBadges() {
    var done = true;
    document.querySelectorAll('.pkcv__reviews .jdgm-prev-badge, .peekora-product__reviews .jdgm-prev-badge').forEach(function (badge) {
      var raw = badge.getAttribute('data-number-of-reviews');
      if (raw === null) { done = false; return; }
      var n = Number(raw) || 0;
      var link = badge.closest('.pkcv__reviews, .peekora-product__reviews') || badge;
      if (n === 0) { link.classList.add('pk-no-reviews'); return; }
      if (n < 10) {
        var trust = badge.querySelector('.pk-review-trust');
        if (!trust) { done = false; return; }
        var label = n + (FR ? (n === 1 ? ' avis' : ' avis') : (n === 1 ? ' review' : ' reviews'));
        if (trust.textContent !== label) trust.textContent = label;
      }
    });
    return done;
  }

  function boot() {
    watchMainAtc();
    var tries = 0;
    (function loop() {
      tries += 1;
      if (!fixBadges() && tries < 20) setTimeout(loop, 400);
      else if (tries < 20) setTimeout(fixBadges, 1500); /* one late pass after Judge.me settles */
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
